import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { pagesAPI } from '../lib/api';

export default function ShippingPolicyPage() {
    const [page, setPage] = useState({ title: 'Shipping Policy', content: '' });
    const [, setLoading] = useState(true);

    useEffect(() => {
        fetchPage();
    }, []);

    const fetchPage = async () => {
        try {
            const response = await pagesAPI.getShippingPolicy();
            if (response.data) setPage(response.data);
        } catch (error) {
            // Using default content
        } finally {
            setLoading(false);
        }
    };

    const defaultContent = `
## Shipping Policy

### Order Processing

All orders are processed within 1-3 business days. Orders are not shipped or delivered on weekends or holidays.

### Shipping Rates & Delivery Estimates

Shipping charges for your order will be calculated and displayed at checkout.

| Shipment method | Estimated delivery time | Shipment cost |
| :--- | :--- | :--- |
| Standard Shipping | 3-5 business days | Free over ₹1499 |
| Express Shipping | 1-2 business days | ₹100 |

### Shipment Confirmation & Order Tracking

You will receive a Shipment Confirmation email once your order has shipped containing your tracking number(s).

### Customs, Duties and Taxes

We are not responsible for any customs and taxes applied to your order. All fees imposed during or after shipping are the responsibility of the customer (tariffs, taxes, etc.).

### Damages

We are not liable for any products damaged or lost during shipping. If you received your order damaged, please contact the shipment carrier to file a claim.
  `;

    return (
        <div className="max-w-4xl mx-auto px-4 py-12" data-testid="shipping-policy-page">
            <Card>
                <CardHeader>
                    <CardTitle className="text-3xl">{page.title}</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="prose prose-slate dark:prose-invert max-w-none">
                        <div className="whitespace-pre-wrap text-muted-foreground leading-relaxed">
                            {page.content || defaultContent}
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
